import { useEffect, useState } from 'react';
import { throttle } from 'throttle-debounce';

const getHeaderType = () => {
  if (typeof window === 'undefined') {
    return 'desktop';
  }
  return window.innerWidth < 768 ? 'mobile' : 'desktop';
}

export const useHeaderType = (ssrDefault) => {
  const [headerType, setHeaderType] = useState(ssrDefault || 'desktop');

  useEffect(() => {
    setHeaderType(getHeaderType());

    const updateLayout = throttle(100, () => {
      setHeaderType(getHeaderType());
    });

    window?.addEventListener('resize', updateLayout);
    return () => {
      window?.removeEventListener('resize', updateLayout);
    }
  }, []);

  return headerType;
}
